module.exports = __webpack_public_path__ + "media/recipes/22-d413ae59.png";